export default __webpack_public_path__ + "static/media/blueground.3623dd9d.png";